<script setup lang="ts">
/**
 * UI-kit component
 * Category: Footers
 * Name: FooterReviewBadge
 * FIGMA: https://www.figma.com/design/NgI2cVJkWODrgnOBHO3Zed/Strapi-Builder--DS-?node-id=3065-830
 *
 * A 24px-tall review-platform wordmark chip for the footer's "As reviewed on" row —
 * wordmark ONLY, no score and no stars (a starred Trustpilot rating is the DS
 * TrustpilotRating/TrustpilotBadge, a different component). Ships as committed
 * Figma exports. The Figma axis value "sitejobber" is a typo of the Sitejabber
 * brand — the code uses 'sitejabber'.
 * Local implementation of the Figma DS component missing from @brighterly/lib-lumee-ui (dsGap).
 */
// types
import type { FooterReviewBadgeProps } from '../types/interfaces'
// hooks
import { useFooterReviewBadge } from '../composables/use-footer-review-badge.hook'

defineOptions({
  name: 'FooterReviewBadge',
})

const props = defineProps<FooterReviewBadgeProps>()

const {
  refImage,
} = useFooterReviewBadge({ props })
</script>

<template>
  <img
    class="footer-review-badge"
    :src="refImage.src"
    :alt="platform"
    :width="refImage.width"
    :height="refImage.height"
    loading="lazy"
  >
</template>

<style lang="scss" scoped src="../styles/_footer-review-badge.scss" />
